import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface ActivityItem {
  id: string;
  occurredAt: string;
  type: string;
  summary: string;
  entityType?: string;
  entityId?: string;
}

// Recent audit activity for a tenant (platform admin Overview tab, UI-SPEC §2.2).
export const activity = (
  tenantId: string,
  params?: { days?: number; limit?: number }
): Promise<ActivityItem[]> =>
  httpRequest.get(`/bil/admin/tenants/${tenantId}/activity`, {
    days : params?.days ?? 30,
    limit: params?.limit ?? 20
  });

// Recent audit activity for the calling tenant (tenant dashboard, UI-SPEC §3.1).
// Server scopes by the authenticated tenant; no tenantId is sent.
export const myActivity = (
  params?: { days?: number; limit?: number }
): Promise<ActivityItem[]> =>
  httpRequest.get("/bil/my/activity", {
    days : params?.days ?? 30,
    limit: params?.limit ?? 20
  });
